import { useQuery } from '@tanstack/react-query';
import { DEFAULT_CURRENCY, type Currency } from '../config/currencies';
import { USER_PREFERENCES_QUERY_KEY, fetchUserPreferences } from '../services/preferencesService';

/**
 * The user's currency (Settings → General). The default while it loads or when
 * it cannot be loaded — amounts are still shown, just labelled with the default.
 */
export function useCurrency(): Currency {
  const { data } = useQuery({
    queryKey: USER_PREFERENCES_QUERY_KEY,
    queryFn: fetchUserPreferences,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return data?.currency ?? DEFAULT_CURRENCY;
}
